import { render, staticRenderFns } from "./switchInput.vue?vue&type=template&id=dea199c2&"
import script from "./switchInput.vue?vue&type=script&lang=js&"
export * from "./switchInput.vue?vue&type=script&lang=js&"
import style0 from "./switchInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VRow,VSwitch})
